import { Model } from '@vuex-orm/core'
import type { Request } from '@vuex-orm/plugin-axios'

/**
 * The Axios plugin for Vuex ORM specifically suggests implementing custom API methods the way that we do:
 * https://vuex-orm.github.io/plugin-axios/guide/custom-actions.html#when-to-use-custom-actions
 *
 * However, TypeScript complains about this:
 * (Actually, it's not complaining any more. Maybe this class is unnecessary after all?
 * Anyway, this class was originally created to make it stop complaining. But even with the relevant bits commented
 * out, I don't see the TypeScript errors any more, sooo...)
 */
export default class BaseModel extends Model {

  declare api: () => Request

}
